import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import { ExposedAPI } from "../../apis/ExposedAPI";
import { URL_REDIRECT } from "../../constant/url";
import { slugify } from "../../utils/utils";

export default function CategoryRedirect() {
  const { category } = useParams();
  const [categorie, setCategorie] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    loadCategory(category);
  }, [category]);

  const loadCategory = (categoryId) => {
    ExposedAPI.getDistantOrStoredCategories()
      .then((categories) => {
        let category = categories.find((cat) => {
          return cat.id + "" === categoryId;
        });
        if (!category) {
          setNotFound(true);
          return;
        }
        setCategorie(category);
      })
      .catch((err) => {
        setNotFound(true);
        console.log(err);
      });
  };

  if (notFound) return <div>Catégorie introuvable</div>;
  if (categorie)
    return <Navigate to={`${URL_REDIRECT.categorie}${slugify(categorie.label)}`} replace />;

  return <div>Redirection...</div>;
}
